var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delete-btn",on:{"click":function($event){return _vm.$emit('delete')}}},[_vm._v("删除")])
}
var staticRenderFns = []

export { render, staticRenderFns }